import React from 'react'
import { object, func } from 'prop-types'
import { renderRoutes } from 'react-router-config'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import FaUser from 'react-icons/lib/fa/user'
import md5 from 'md5'

import { simpleName } from '../../../utils/helpers'
import { withContext } from '../../../utils/withContext'
import { putRequest } from '../../helpers/requestActions'
import { Loading } from '../../components'
import { Success, Error } from '../../components/Messages'
import styles from './ProfilePage.styl'

class ProfilePage extends React.Component {
	static fetchQueries = [
		'athletes/profile'
	]

	static propTypes = {
		route: object,
		fetchResults: object,
		fetchStatus: object,
		dispatch: func,
		context: object
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		const { fetchResults, fetchStatus } = nextProps
		const { lastFetched } = prevState
		const { status, lastRead } = (fetchStatus[md5(ProfilePage.fetchQueries[0])] || {})
		if (status === 'success' && lastFetched !== lastRead) {
			return { athlete: fetchResults[ProfilePage.fetchQueries[0]], lastFetched: lastRead }
		}
		return null
	}

	constructor(props) {
		super(props)
		this.state = { message: false, error: false, isPhone: true }
		this.handleSubmit = this.handleSubmit.bind(this)
	}

	handleSubmit(e, athlete) {
		putRequest(`/api/athletes/update/me`, { ...athlete })
			.then(() => {
				this.setState({ message: true, athlete })
				setTimeout(() => { this.setState({ message: false }) }, 1500)
			})
			.catch(err => {
				this.setState({ error: true })
				setTimeout(() => { this.setState({ error: false }) }, 1500)
			})
	}

	render() {
		const { message, error, isPhone, athlete } = this.state
		const { route, context: { i18n, createLocaleLink } } = this.props
		const navigation = [
			{ name: i18n`account_info_label`, link: '' },
			{ name: i18n`biometric_info_label`, link: 'biometric' },
			{ name: i18n`challanges_objectives_label`, link: 'challenge' },
			{ name: i18n`weight_evolution_label`, link: 'weight' },
			{ name: i18n`billing_info_label`, link: 'billing' },
			{ name: i18n`subscriptions_label`, link: 'subscriptions' },
			{ name: 'Mudar Password', link: 'password' }
		]
		const renderedNavigation = navigation.map((ele, index) => (
			<li
				key={ index }
				className={ isPhone ? styles['mobile-list'] : null }
				style={ { transition: `opacity ${ 250 * (index + 1) }ms linear` } }
			>
				<NavLink
					exact
					to={ createLocaleLink(`/apt/profile/${ ele.link }`) }
					activeClassName={ styles['active'] }
					onClick={ () => { this.setState({ isPhone: true }) } }
				>
					{ ele.name }
				</NavLink>
			</li>
		))

		return (
			<div className={ styles['profile'] }>
				{ message ? <Success /> : null }
				{ error ? <Error /> : null }
				<div className={ styles['content'] }>
					<div className={ styles['avatar-container'] }>
						<div className={ styles.avatar }><i><FaUser /></i></div>
						<h2 className={ styles['username'] }>{ (athlete || {}).name ? simpleName(athlete.name) : 'Utilizador' }</h2>
						<div className={ styles.membersince }><small>Membro desde . 12-2016</small></div>
						<span onClick={ () => { this.setState({ isPhone: !isPhone }) } } className={ `${ styles['mobile-burger'] } ${ !isPhone ? styles['is-open'] : null }` }><span /></span>

						<ul className={ `${ isPhone ? styles['mobile-hidden'] : null } ${ styles.anchorUl }` }>
							{ renderedNavigation }
							{/* <li><Link to="/user_profile/change_password" className={styles['active']}>Alteração da password</Link></li> */ }
						</ul>
					</div>
					<div className={ styles['rendered-routes'] }>
						{ athlete ? renderRoutes(route.routes, { athlete, handleSubmit: this.handleSubmit }) : <Loading /> }
					</div>
				</div>
			</div >
		)
	}
}

const mapStateToProps = state => ({
	fetchResults: state.fetch.results,
	fetchStatus: state.fetch.status
})

export default withContext(connect(mapStateToProps)(ProfilePage))



// WEBPACK FOOTER //
// ./src/client/webapp/pages/ProfilePage/ProfilePage.js